module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n  var i18n = require(\'@cdo/netsim/locale\');\n\n  var shouldShowTab = require(\'./NetSimUtils\').shouldShowTab;\n  var NetSimTabType = require(\'./NetSimConstants\').NetSimTabType;\n\n  var showInstructions = shouldShowTab(level, NetSimTabType.INSTRUCTIONS);\n  var showMyDevice = shouldShowTab(level, NetSimTabType.MY_DEVICE);\n  var showRouter = shouldShowTab(level, NetSimTabType.ROUTER);\n  var showDns = shouldShowTab(level, NetSimTabType.DNS);\n%>\n<div class="netsim-tabs">\n  <ul>\n    <% if (showInstructions) { %>\n    <li><a href="#tab_instructions"><%= i18n.instructions() %></a></li>\n    <% } %>\n    <% if (showMyDevice) { %>\n      <li><a href="#tab_my_device"><%= i18n.myDevice() %></a></li>\n    <% } %>\n    <% if (showRouter) { %>\n      <li><a href="#tab_router"><%= i18n.router() %></a></li>\n    <% } %>\n    <% if (showDns) { %>\n      <li><a href="#tab_dns"><%= i18n.dns() %></a></li>\n    <% } %>\n  </ul>\n  <% if (showInstructions) { %>\n    <div id="tab_instructions"></div>\n  <% } %>\n  <% if (showMyDevice) { %>\n    <div id="tab_my_device"></div>\n  <% } %>\n  <% if (showRouter) { %>\n    <div id="tab_router"></div>\n  <% } %>\n  <% if (showDns) { %>\n    <div id="tab_dns"></div>\n  <% } %>\n</div>\n', __filename = "src/netsim/NetSimTabsComponent.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            var i18n = require("@cdo/netsim/locale");
            var shouldShowTab = require("./NetSimUtils").shouldShowTab;
            var NetSimTabType = require("./NetSimConstants").NetSimTabType;
            var showInstructions = shouldShowTab(level, NetSimTabType.INSTRUCTIONS);
            var showMyDevice = shouldShowTab(level, NetSimTabType.MY_DEVICE);
            var showRouter = shouldShowTab(level, NetSimTabType.ROUTER);
            var showDns = shouldShowTab(level, NetSimTabType.DNS);
            __line = 11;
            __append('\n<div class="netsim-tabs">\n  <ul>\n    ');
            __line = 14;
            if (showInstructions) {
                __append('\n    <li><a href="#tab_instructions">');
                __line = 15;
                __append(escapeFn(i18n.instructions()));
                __append("</a></li>\n    ");
                __line = 16;
            }
            __append("\n    ");
            __line = 17;
            if (showMyDevice) {
                __append('\n      <li><a href="#tab_my_device">');
                __line = 18;
                __append(escapeFn(i18n.myDevice()));
                __append("</a></li>\n    ");
                __line = 19;
            }
            __append("\n    ");
            __line = 20;
            if (showRouter) {
                __append('\n      <li><a href="#tab_router">');
                __line = 21;
                __append(escapeFn(i18n.router()));
                __append("</a></li>\n    ");
                __line = 22;
            }
            __append("\n    ");
            __line = 23;
            if (showDns) {
                __append('\n      <li><a href="#tab_dns">');
                __line = 24;
                __append(escapeFn(i18n.dns()));
                __append("</a></li>\n    ");
                __line = 25;
            }
            __append("\n  </ul>\n  ");
            __line = 27;
            if (showInstructions) {
                __append('\n    <div id="tab_instructions"></div>\n  ');
                __line = 29;
            }
            __append("\n  ");
            __line = 30;
            if (showMyDevice) {
                __append('\n    <div id="tab_my_device"></div>\n  ');
                __line = 32;
            }
            __append("\n  ");
            __line = 33;
            if (showRouter) {
                __append('\n    <div id="tab_router"></div>\n  ');
                __line = 35;
            }
            __append("\n  ");
            __line = 36;
            if (showDns) {
                __append('\n    <div id="tab_dns"></div>\n  ');
                __line = 38;
            }
            __append("\n</div>\n");
            __line = 40;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}